import { BlockTableRoot } from "./BlockTableRoot";
import { useBlockTable } from "./useBlockTable";

export const BlockTable = {
  Root: BlockTableRoot,
  store: useBlockTable,
}
